import { createReducer, on } from '@ngrx/store';

import * as UserPortfolioActions from './user-portfolio.actions';
import { IUserPortfolioState } from './interfaces/user-portfolio.state.interface';

const initState: IUserPortfolioState = {
  userInvations: [],
}

export const userPortfolioReducers = createReducer(
  initState,
  on(UserPortfolioActions.getUserInvationsSuccess, (state, { data }) => ({
    ...state,
    userInvations: data,
  })),
  on(UserPortfolioActions.clearStore, () => initState),
);
